import { patientApi } from '@/api/PatientApi'
import { useQuery } from '@tanstack/react-query'

export const useFetchMembershipStatus = () => {
	const { data, isLoading } = useQuery({
		queryKey: ['patient-membership-status'],
		queryFn: patientApi.getMembershipStatus,
		select: (data) => data.status,
	})

	return {
		status: data,
		isFetchingStatus: isLoading,
		hasActiveMembership: data === 'ACTIVE',
	}
}
